/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuditStatusEnum } from './auditStatusEnum';
import { AuditData } from './auditData';


export interface AuditLog { 
    /**
     * Unique Identifier representing the Audit data
     */
    audit_id?: string;
    status?: AuditStatusEnum;
    audit_data?: AuditData;
    /**
     * Date Time when this entry was made
     */
    created_date_time?: Date;
    /**
     * Reason why the Audit publishing failed. Error message from CSP Audit SDK
     */
    error_msg?: string;
    /**
     * The amount of times that was tried to upload to vRealize
     */
    retry_count?: number;
    /**
     * Date time when this Audit Log was last updated
     */
    updated_date_time?: Date;
}
export namespace AuditLog {
}


